import { router, useGlobalSearchParams } from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { ActionSheet, tokens } from '@fhs/ui';

import { CartActionRemoveItem } from '../components/cart-components/action-remove-item';
import { CartActionRemoveOffer } from '../components/cart-components/action-remove-offer';
// import { UpsellModal } from '../components/cart-components/upsell-items';

import { CartReview } from './_cart';

const onClose = () => router.setParams({ action: undefined, id: undefined });

export function CartScreen() {
  const { action, id } = useGlobalSearchParams<{
    action: 'remove-offer' | 'remove-item' | 'upsell';
    id: string;
  }>();
  const showRemoveOfferSelector = action === 'remove-offer';
  const showRemoveItemSelector = action === 'remove-item';
  // const showUpsellModal = action === 'upsell';

  return (
    <>
      <View style={styles.page}>
        <View style={styles.inner}>
          <CartReview />
        </View>
      </View>
      {showRemoveOfferSelector && (
        <ActionSheet isVisible onClose={onClose}>
          <CartActionRemoveOffer id={id} onClose={onClose} />
        </ActionSheet>
      )}
      {showRemoveItemSelector && (
        <ActionSheet isVisible onClose={onClose}>
          <CartActionRemoveItem cartId={id} onClose={onClose} />
        </ActionSheet>
      )}
      {/* {showUpsellModal && (
        <ActionSheet isVisible onClose={onClose}>
          <UpsellModal onClose={onClose} />
        </ActionSheet>
      )} */}
    </>
  );
}

const styles = StyleSheet.create({
  page: {
    backgroundColor: 'white',
    borderTopColor: tokens.colors.$black10,
    borderTopWidth: 1,
    flex: 1,
  },
  inner: {
    flex: 1,
    width: '100%',
    maxWidth: 908,
    marginHorizontal: 'auto',
  },
});
